// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { Color } from '@models/color';
import { GuidTools } from '@models/guid';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CommunicationEquipment } from '@models/imported/SagaSchema/CommunicationEquipment';
import { Vehicle } from '@models/imported/SagaSchema/Vehicle';
import { ListResourceStatus } from '@models/imported/SagaStateLib/ListResourceStatus';
import { CacheChangedInterface } from '@services/cache/cache.service';
import { FetchListService } from '@services/fetchlist/fetchlist.service';
import { UnitActivity_abstract } from './../abstract/SagaSchema/UnitActivity_abstract';

export class UnitActivity extends UnitActivity_abstract {
  static globalIcon: string = 'md-directions_car';

  public devices: CommunicationEquipment[] = [];
  public vehicles: Vehicle[] = [];

  defaultColor: Color = new Color('black');

  private _status: ListResourceStatus;
  get status(): ListResourceStatus {
    return this._status;
  }

  set status(status: ListResourceStatus) {
    this._status = status;
    this.Status = status.Value;
  }

  private _callcard: CallCard;
  get callcard(): CallCard {
    return this._callcard;
  }

  set callcard(value: CallCard) {
    this._callcard = value;
    this.CallCardID = value ? value.ObjGuid : GuidTools.Empty;
  }

  get mainRessource() {
    if (this.MainResourceUId) {
      return this.devices.find(device => device.ObjGuid === this.MainResourceUId);
    }

    return null;
  }

  get vehicle() {
    return this.vehicles.length ? this.vehicles[0] : null;
  }

  get positionProvider() {
    return this.vehicles.length ? this.vehicles[0] : null;
  }

  set positionProvider(vehicle: Vehicle) {
    this.PositionProviderUId = vehicle.ObjGuid;
  }

  get color(): Color {
    return (this.status && this.status.color) || this.defaultColor;
  }

  get colorRgb(): string {
    return this.color.toRgbString();
  }

  get icon() {
    return this.vehicle ? this.vehicle.icon : UnitActivity.globalIcon;
  }

  setListResourceStatus(fetchList: FetchListService) {
    const row = fetchList.getRow(ListResourceStatus, this.Status);
    if (row != null) {
      this._status = row;
    }
  }

  changed(changed: CacheChangedInterface) {
    super.changed(changed);
    this._changed.next();
  }

  rShort(): string {
    return this.mainRessource ? this.mainRessource.fullCallsign : this.Name;
  }

  export(): any {
    return {
      owner: this.Owner,
      equipments: this.devices.map(d => d.ObjGuid),
      vehicles: this.vehicles.map(v => v.ObjGuid)
    };
  }

  isValid() {
    return this.devices.length && this.vehicles.length;
  }
}
